/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useFormik } from "formik";
import {
  Grid,
  Container,
  Box,
  Divider,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import * as yup from "yup";
import CustomModal from "../../modals/CustomModal";
import SaveCancelButtons from "../../SaveCancelButtons";
import "dayjs/locale/en-gb";
import { toast } from "react-toastify";
import CoeAutocomplete from "../../CoeAutocomplete";
import { LoadingButton } from "@mui/lab"; // Asegúrate de que esta ruta sea correcta
import SearchIcon from "@mui/icons-material/Search";
import { ModeloGetUrl, ModeloPost } from "../../ModeloCrud";
import CustomDataGrid from "../../CustomDataGrid";
import DeleteIcon from "@mui/icons-material/Delete";

const validationSchema = yup.object({});

export default function ModalOdontologosListas({
  showModal,
  hideModal,
  listaRow,
  afterSave,
}) {
  const [myloading, setMyLoading] = React.useState(false);
  const [selectedClinica, setSelectedClinica] = useState(null);
  const [selectedEspecialidad, setSelectedEspecialidad] = useState(null);
  const [selectedOdontologo, setSelectedOdontologo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [odontologoListasRows, setOdontologoListasRows] = useState([]);
  const viewportHeight = window.innerHeight;
  const gridHeight = viewportHeight - 400;

  const handleOnChange = () => {};
  const handleQuitar = (row) => {
    console.log("Quitar lista de honorarios de odontólogo:", row);
    grabar(true, row.coe_id);
  };

  const columnsObject = [
    {
      field: "coe_id",
      headerName: "Id",
      width: 30,
    },
    {
      field: "clinica",
      headerName: "Clínica",
      width: 80,
    },
    {
      field: "especialidad",
      headerName: "Especialidad",
      width: 130,
    },
    {
      field: "dia_semana",
      headerName: "Dia",
      width: 100,
    },
    {
      field: "turno",
      headerName: "Turno",
      width: 75,
    },
    {
      field: "lista",
      headerName: "Lista",
      width: 100,
    },
    {
      field: "acciones",
      headerName: "Acciones",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Tooltip title="Quitar lista de honorarios">
          <IconButton onClick={() => handleQuitar(params.row)}>
            <DeleteIcon fontSize="small" color="error" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const handleBuscarOdontologosListas = async () => {
    try {
      if (!selectedClinica || !selectedEspecialidad || !selectedOdontologo) {
        toast.warning("Por favor, seleccione todos los campos requeridos.");
        return; // Agregar return para evitar continuar si falta información
      }
      const params = new URLSearchParams({
        centro_id: selectedClinica?.id,
        especialidad_id: selectedEspecialidad?.id,
        odontologo_id: selectedOdontologo?.id,
      });
      setMyLoading(true);
      let result = await ModeloGetUrl(
        "centro-odontologo-especialidad",
        null,
        "vista-odontologos-listas",
        params
      );
      setMyLoading(false);
      if (result.error) {
        toast.error("Error al buscar valores vigentes: " + result.mensaje);
      } else if (result.listado && result.listado.length > 0) {
        console.log("Valores vigentes encontrados:", result.listado);
        setOdontologoListasRows(result.listado);
      }
    } catch (error) {
      toast.error("Error al buscar valores vigentes: " + error.message);
    } finally {
    }
  };

  const handleClose = () => {
    // limpia el form antes de cerrar
    setSelectedClinica(null);
    setSelectedEspecialidad(null);
    setSelectedOdontologo(null);
    setOdontologoListasRows([]);
    formik.resetForm();
    hideModal();
  };
  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validationSchema,
    onSubmit: () => {
      grabar(false, null);
    },
  });

  async function grabar(listaNull = false, myCoeId = null) {
    if (!odontologoListasRows || odontologoListasRows.length === 0) {
      toast.warning("Debe haber al menos una fila.");
      return;
    }
    setMyLoading(true);
    const Data = {
      "lista-id": !listaNull ? listaRow?.id : null,
    };
    const coeId = odontologoListasRows[0].coe_id;
    let result = await ModeloPost(
      "centro-odontologo-especialidad",
      myCoeId ? myCoeId : coeId,
      "update-lista-honorarios",
      Data
    );
    if (result.error) {
      toast.error("Error al actualizar: " + result.mensaje);
      setMyLoading(false);
      return;
    } else {
      console.log("Actualización exitosa para ID:", coeId);
    }
    setMyLoading(false);
    toast.success("Actualización completada.");
    handleBuscarOdontologosListas();
  }

  return (
    <CustomModal
      open={showModal}
      onClose={handleClose}
      title="Odontólogos listas"
      disableActions
      width="75%"
      maxWidth="800px"
      icon={<i className="fa-solid fa-user-doctor"></i>}
    >
      <Container>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1} sx={{ ml: -4 }}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Lista de honorarios: {listaRow?.nombre}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ ml: -2 }}>
              <Box
                display="flex"
                flexDirection="row"
                spacing={2}
                alignItems="center"
              >
                <CoeAutocomplete
                  selectedClinica={selectedClinica}
                  selectedEspecialidad={selectedEspecialidad}
                  selectedOdontologo={selectedOdontologo}
                  setSelectedClinica={setSelectedClinica}
                  setSelectedEspecialidad={setSelectedEspecialidad}
                  setSelectedOdontologo={setSelectedOdontologo}
                  handlebusqueda={null}
                  loading={loading}
                  handleOnChange={handleOnChange}
                />
                <Tooltip title="Buscar listas de honorarios">
                  <LoadingButton
                    size="medium"
                    onClick={handleBuscarOdontologosListas}
                    loading={myloading}
                    loadingPosition="start"
                    endIcon={<SearchIcon />}
                    sx={{
                      backgroundColor: "primary.main",
                      ":hover": { bgcolor: "#475569", color: "white" },
                      width: 80,
                      minWidth: 80,
                      mt: -3,
                    }}
                    variant="contained"
                  >
                    <span></span>
                  </LoadingButton>
                </Tooltip>
              </Box>
            </Grid>
            <Grid item xs={12}>
              {!myloading && odontologoListasRows?.length > 0 && (
                <CustomDataGrid
                  columnsObject={columnsObject}
                  dataRows={odontologoListasRows}
                  //       sortField="codigo"
                  //     sortOrder="desc"
                  //  dynamicRowHeightField="notas"
                  columnPercentage={0.4}
                  getRowId={(row) => row.coe_id}
                  pageSize={100}
                  height={gridHeight}
                />
              )}
            </Grid>
          </Grid>
          <Divider sx={{ mt: 3 }} />
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <SaveCancelButtons
              handleCancel={handleClose}
              loading={myloading}
              isModal={true}
            />
          </Box>
        </form>
      </Container>
    </CustomModal>
  );
}
